module.exports = __webpack_public_path__ + "img/loader-reload.990ce9a5.svg";